import { render, staticRenderFns } from "./profile-selector-list.vue?vue&type=template&id=6a0d2d38&scoped=true&"
import script from "./profile-selector-list.vue?vue&type=script&lang=js&"
export * from "./profile-selector-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0d2d38",
  null
  
)

export default component.exports